import { render, staticRenderFns } from "./details-page.vue?vue&type=template&id=93042ece&scoped=true"
import script from "./details-page.vue?vue&type=script&lang=js"
export * from "./details-page.vue?vue&type=script&lang=js"
import style0 from "./details-page.vue?vue&type=style&index=0&id=93042ece&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93042ece",
  null
  
)

export default component.exports